module.exports = __webpack_public_path__ + "img/index-b-slide1.d7f87c21.jpg";